import { createGlobalStyle } from 'styled-components';
import { devices } from './device';
const GlobalStyle = createGlobalStyle`
:root {
  --font-family: 'Lato';
  --box-shadow: 0px 2px 26px rgba(0, 0, 0, 0.0741095);
  --bg-color: #FFFFFF;
  --bs-primary: #FFBF00 !important;
  --bs-primary-yellow: #FFEFBF !important;
  --bs-body-font-size: 14px !important;
  --light-yellow: #FFF3DC;
  --bs-link-color: #04AAFF !important;
  --bs-grey: #DCDCDE;
  --bs-etiqa-teal: #49C0B6;
  --bs-etiqa-grey: #707070;
  --bs-etiqa-pale-yellow: #FFF3CE;
  --bs-etiqa-light-teal: #D1EFED;
  --pale-yellow: #FFDF7F;
  ;
}

.form-floating > .form-control:focus ~ label,
  .form-floating > .form-control:not(:placeholder-shown) ~ label {
    @media only screen and ${devices.xs} {
      font-size: 12px;
    }
    @media only screen and ${devices.lg} {
      font-size:14px;
    }
}

.form-floating > .form-control ~ label {
  color: var(--bs-etiqa-grey) !important;
}

.form-control {
  border-color: #B1B1B1 !important;
}

input[type="range"]::-webkit-slider-runnable-track {
  width: 100%;
  height: 8px;
  no-repeat;
  border-radius: 8px;
  outline: 1px solid #707070;
}

input[type="range"]::-webkit-slider-runnable-track::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to right, white 0%, white 100%); /* Apply the gradient as background */
  outline: 1px solid #707070; /* Add a solid 1px outline */
}

input[type="range"]::-moz-range-track {
  background: linear-gradient(to right, #to right 0%, #to right 50%, #FFFFFF) no-repeat;
}

input[type="range"]::-ms-fill-lower {
  background: linear-gradient(to right, #to right 0%, #to right 50%, #FFFFFF) no-repeat;
}

input[type="range"]::-ms-fill-upper {
  background: #FFFFFF;
}

input[type="range"]::-webkit-slider-thumb {
  width: 20px;
  height: 20px;
  background: white;
  border-radius: 50%;
  cursor: pointer;
  border: 1px solid #B8BABC;
  margin-top: -6px;
}

// .form-control {
//   max-width: 467px;
//   max-height: 56px;
// }

.form-floating {
  font-size: 20px;
}

.dropdown-menu {
  --bs-dropdown-link-active-bg: #FFBF00 !important;
}

.btn-primary {
  --bs-btn-bg: #FFBF00 !important;
  --bs-btn-border-color: none !important;
  --bs-btn-hover-bg: #333333 !important;
  --bs-btn-hover-border-color: transparent !important;
  --bs-btn-disabled-bg: #F2F2F2 !important;
  --bs-btn-active-border-color: transparent !important;
  --bs-btn-active-bg: #FFBF00 !important;
  --bs-btn-active-color: black !important;
  --bs-btn-disabled-border-color: #F2F2F2 !important;
  --bs-btn-disabled-bg: #B8BABC;
  --bs-btn-disabled-opacity: 1 !important;
  --bs-btn-color: black !important;
  --bs-btn-font-weight: 700 !important;
  max: height: 64px;
}

span, a {
  text-decoration: none;
  font-weight: 500;
}

* {
  box-sizing: border-box;
  font-family: var(--font-family);
}

.box-container{
  border: none;
  box-shadow: var(--box-shadow);
  background-color: var(--bg-color);
  border-radius: 4px;
}

.container ul {
  padding-left: 1em
}

container  {
  border: 1px solid red !important;
}

ol > li {
  list-style: inherit;
}

small {
  color: #354F53;
  font-size: 10px;
}

.form-check-input:checked {
  background-color: var(--bs-primary) !important;
  border-color: var(--bs-primary) !important;
}

.input-bg-success .form-check-input:checked {
  background-color: rgb(var(--bs-success-rgb)) !important;
  border-color: rgb(var(--bs-success-rgb)) !important;
}

.form-check-input:focus {
  box-shadow: unset !important;
}
.card-title {
  font-weight: 700 !important;
  font-size: 20px !important;
}

.text-12px {
  font-size: 12px;
}

.btn-xs {
  padding: .25rem .5rem !important;
  font-size: 10px !important
}


.btn-check+.btn {
  border: 1px solid #B1B1B1 !important;
  border-radius: 8px;
  hidden
}

.accordion {
  --bs-accordion-btn-color: inherit !important;
  --bs-accordion-btn-bg: inherit !important;
  --bs-accordion-active-color: inherit !important;
  --bs-accordion-active-bg: inherit !important;
}

.shadow-none .accordion-button {
  box-shadow: none !important;
}

.accordion-button::after {
  background-image: var(--bs-accordion-btn-icon) !important;
}

.text-white .accordion-button::after {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23f8f9fa'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e") !important;
}

.bg-etiqa-primary {
  background-color: var(--bs-primary) !important;
}

.border-etiqa-primary.border,
.border-etiqa-primary.border-top,
.border-etiqa-primary.border-bottom,
.border-etiqa-primary.border-start,
.border-etiqa-primary.border-end {
  border-color: var(--bs-primary) !important;
}

// Custom styles.
.bg-lightyellow {
  background-color: var(--light-yellow) !important;
}

.pre-line {
  white-space: pre-line;
}

.custom-card {
padding: 16px 24px 16px 24px;
border-radius: 8px 8px 8px 8px;
border: 2px 2px 2px 2px;
}

.custom-card-body {
  padding: 0;
  }

.card {
  border: none !important;
  border-radius: 12px !important;
}

// .card-body {
//   padding-left: 48px;
//   padding-right: 48px;
//   padding-top: 24px;
//   padding-bottom: 24px;
// }

.a-link {
  font-family: 'Lato';
  font-weight: 600;
  color:#0091FF !important;
  // color:#0251C5 !important;
  text-decoration: underline;
}

.a-link-none-line {
  font-family: 'Lato';
  font-weight: 600;
  color:#0091FF !important;
  text-decoration: none;
  cursor:pointer;
}

.accordion-button:focus {
  box-shadow: none !important;
}

.rdp {
  --rdp-accent-color: #FFBF00 !important;
}

.color-bs-primary {
  color: var(--bs-primary);
}

.color-bs-grey {
  color: var(--bs-grey);
}

.color-bs-teal {
  color: var(--bs-etiqa-teal);
}

.color-bs-grey {
  color: var(--bs-etiqa-grey);
}

.bg-bs-teal {
  background-color: var(--bs-etiqa-teal);
}

.bg-bs-pale-yellow {
  background-color: var(--bs-etiqa-pale-yellow);
}

.weight-700 {
  font-weight: 700;
}

.weight-400 {
  font-weight: 400;
}

.text-16px {
  font-size: 16px!important;
}

.text-14px {
  font-size: 14px;
}

.text-12px {
  font-size: 12px;
}

.text-18px {
  font-size: 18px;
}

.text-20px {
  font-size: 20px;
}

.text-24px {
  font-size: 24px;
}
.text-32px {
  font-size:32px;
}

@media screen and ${devices.xs} {
  :root{
    font-size: 14px;
  }
  
}
@media screen and ${devices.lg} {
  :root{
    font-size: 16px;
  }
}

.cursor-pointer {
  cursor: pointer;
}


.text-dark{
  font-weight: bolder;
  margin-top: 0.4rem;
  font-size: 14px;
  transition: color 2s ease-in-out;
}

`;

export default GlobalStyle;
